import { render } from "./assurances.vue?vue&type=template&id=6f7b35a4&scoped=true"
import script from "./assurances.vue?vue&type=script&lang=js"
export * from "./assurances.vue?vue&type=script&lang=js"

import "./assurances.vue?vue&type=style&index=0&id=6f7b35a4&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f7b35a4"]])

export default __exports__